import React from 'react';
import { ContainerObservacao } from '../fields/styles';
import { useAgendContas } from '../../hook/useAgendContas';
import { InputTextArea } from '~/components/NovosInputs';
import { Col } from 'react-bootstrap';
import Separator from '~/components/Separator';

export const Observacao: React.FC = () => {
  const { formAgendamento } = useAgendContas();
  const { register, control, errors } = formAgendamento;

  return (
    <ContainerObservacao>
      <Col sm={12} md={12} className="separator">
        <Separator labelText="Observação" />
      </Col>
      <Col sm={12} md={12}>
        <InputTextArea
          register={register}
          control={control}
          maxLength={100}
          isError={!!errors.des_observacao}
          name="des_observacao"
        />
      </Col>
    </ContainerObservacao>
  );
};
